import clonedeep from "lodash.clonedeep";

import { IterUtils } from "../../../../../../Common/IterableUtils";
import { arrayHasAtLeastOneItem } from "../../../../../../Common/TypingUtils";
import { FullFormAction } from "../../Store/FullFormAction";
import { FullFormState } from "../../Store/FullFormState";

import { ModelActionType } from "./modelActions";
import { mergeViewModel } from "./MergeViewModel";

export function modelReducer(state: FullFormState, action: FullFormAction): FullFormState {
    switch (action.type) {
        case ModelActionType.SetValues: {
            const { values, deleted } = action.payload;
            const redefinedViewModels = state.redefinedViewModels || [];
            const redefinedModel = redefinedViewModels[redefinedViewModels.length - 1];

            if (redefinedModel) {
                const nextViewModel = mergeViewModel(redefinedModel, values, deleted);
                const nextViewModels = [...redefinedViewModels.slice(0, -1), nextViewModel];

                return { ...state, redefinedViewModels: nextViewModels };
            }

            return {
                ...state,
                viewModel: mergeViewModel(state.viewModel, values, deleted),
            };
        }
        case ModelActionType.ClearModel: {
            return {
                ...state,
                viewModel: {},
            };
        }
        case ModelActionType.redefineModel: {
            return redefineModel(state);
        }
        case ModelActionType.MergeRedefinedModel: {
            return mergeRedefinedModel(state);
        }
        case ModelActionType.DropRedefinedModel: {
            return dropRedefinedModel(state);
        }
        default:
            return state;
    }
}

function redefineModel(state: FullFormState): FullFormState {
    const redefinedViewModels = state.redefinedViewModels || [];
    if (!arrayHasAtLeastOneItem(redefinedViewModels)) {
        return { ...state, redefinedViewModels: [clonedeep(state.viewModel)] };
    }

    const nextRedefinedModel = clonedeep(IterUtils.last(redefinedViewModels));
    const nextRedefinedViewModels = [...redefinedViewModels, nextRedefinedModel];

    return { ...state, redefinedViewModels: nextRedefinedViewModels };
}

function mergeRedefinedModel(state: FullFormState): FullFormState {
    if (state.redefinedViewModels && arrayHasAtLeastOneItem(state.redefinedViewModels)) {
        const nextModel = IterUtils.last(state.redefinedViewModels);
        return state.redefinedViewModels.length === 1
            ? { ...state, viewModel: nextModel, redefinedViewModels: [] }
            : { ...state, redefinedViewModels: [...state.redefinedViewModels.slice(0, -2), nextModel] };
    }

    // eslint-disable-next-line no-console
    console.error("Called mergeRedefinedModel, but redefinedViewModels is empty");
    return state;
}

function dropRedefinedModel(state: FullFormState): FullFormState {
    if (state.redefinedViewModels && state.redefinedViewModels.length) {
        return { ...state, redefinedViewModels: state.redefinedViewModels.slice(0, -1) };
    }

    // eslint-disable-next-line no-console
    console.error("Called dropRedefinedModel, but redefinedViewModels is empty");
    return state;
}
